import { render, staticRenderFns } from "./description.vue?vue&type=template&id=530ca1f0&scoped=true&"
import script from "./description.vue?vue&type=script&lang=ts&"
export * from "./description.vue?vue&type=script&lang=ts&"
import style0 from "./description.vue?vue&type=style&index=0&id=530ca1f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ca1f0",
  null
  
)

export default component.exports